import React from 'react';
import Select from '@/components/ui/Select';
import FormItem from '@/components/ui/FormItem';
import { SelectOption } from '@/components/ui/SelectOptions/types';

interface ResponsibleFormItemProps {
	usersOptions: SelectOption[];
	isLoading: boolean;
}

export function ResponsibleFormItem({ usersOptions, isLoading }: Readonly<ResponsibleFormItemProps>): JSX.Element {
	return (
		<FormItem label="Responsible" name="responsible" required>
			<Select loading={isLoading} placeholder="Responsible" options={usersOptions} />
		</FormItem>
	);
}
